module.exports = __webpack_public_path__ + "static/media/carroussel_23.5d93e86d.jpg";